// extracted by mini-css-extract-plugin
export default {"productImagesContainer":"ProductsImages_productImagesContainer__bS4n7","tabContainer":"ProductsImages_tabContainer__NJAp8"};